<template>
  <form @submit.prevent="submit">
    <div class="form-row">
      <div class="form-group col-lg-6">
        <label for="feature-quantity">نام دسته بندی</label>
        <input v-model="form.category" type="text" class="form-control" id="feature-quantity">
      </div>
      <div class="form-group col-lg-6">
        <label for="feature-quantity">اولویت</label>
        <input v-model="form.category_order" type="text" class="form-control" id="feature-quantity">
      </div>
    </div>

    <b-btn variant="primary" type="submit">ثبت</b-btn>

  </form>
</template>

<script>
export default {
  name: "FeatureCategoryManager",
  props: {
    featureCategory: {},
    product: {}
  },
  data() {
    return {
      form: {}
    }
  },
  methods: {
    productFeatureCategories() {
      let categories = []


      this.product.features.forEach(item => {
        const extra = item.extra;
        categories.push(extra)
      })

      let uniqueCategories = categories.filter((obj, index, self) =>
          index === self.findIndex((t) => t.category_order === obj.category_order && t.category === obj.category)
      );

      return uniqueCategories;


    },
    findCategory() {
      let productFeatureCategories = this.productFeatureCategories()

      for (let i = 0; i < productFeatureCategories.length; i++) {
        let item = productFeatureCategories[i];

        if (item.category == this.featureCategory) {
          return item
        }
      }
      return false
    },
    submit() {
      // change all feature with current category to be same as user changes.
      this.product.features.forEach((feature, index) => {
        let featureCategory = feature.extra.category
        if (featureCategory == this.featureCategory) {
          console.log(this.form)
          feature['extra']['category'] = this.form.category
          feature['extra']['category_order'] = parseInt(this.form.category_order)

        }
      })
      console.log(this.product.features)
      this.$emit('changeCategories', true)
    }
  },
  mounted() {
    this.form = Object.assign({}, this.findCategory())
  }

}
</script>

<style scoped>

</style>